module.exports = __webpack_public_path__ + "static/media/features-split-top-01.49ac2e3b.png";